/* RESPONSIBLE TEAM: team-ai-agent-2 */

import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentGuidanceShowRoute extends IntercomRoute {
  @service declare appService: AppService;

  reactEnabled() {
    return this.appService.app.canUseFeature('react-guidance-page');
  }
}

export default ReactRoute(AutomationFinAIAgentGuidanceShowRoute, {
  overrideRenderTemplate: false,
});
